import config from "@/data/config";

const env = {
  getters: {
    authMode() {
      return import.meta.env.VITE_AUTH_MODE || "onid";
    },
    isDebugMode() {
      return import.meta.env.VITE_DEBUG === "true";
    },
    useAuth() {
      return import.meta.env.VITE_DO_AUTH === "true";
    },
    useDatastore() {
      return import.meta.env.VITE_USE_DATASTORE === "true";
    },
    useLandingPage() {
      return config.settings.useLandingPage === true;
    },
    useNavbar() {
      return config.settings.useNavbar === true;
    },
    course_name() {
      return import.meta.env.VITE_COURSE_NAME;
    },
    publicKey(state, getters) {
      let key = "";
      if (getters.authMode === "onid") {
        key = import.meta.env.VITE_PUBLIC_KEY;
      } else {
        let token = getters.getDecodedToken;
        key = token.aud || "";
      }
      return key;
    },
    getAchievementsApiKey() {
      return import.meta.env.VITE_ACHIEVEMENTS_API_KEY;
    },
    getQuestionsApiKey() {
      return import.meta.env.VITE_QUESTIONS_API_KEY;
    },
    getAwardedPointsApiKey() {
      return import.meta.env.VITE_AWARDED_POINTS_API_KEY;
    },
    getAchievementsGlossaryLink() {
      return import.meta.env.VITE_ACHIEVEMENTS_LINK;
    },
    getQuestionsGlossaryLink() {
      return import.meta.env.VITE_QUESTIONS_LINK;
    },
    getAwardedPointsGlossaryLink() {
      return import.meta.env.VITE_AWARDED_POINTS_LINK;
    }
  }
};

export default env;
